import { IStateTask, IStoreState } from 'src/entity/StateEntity';
import { Dispatch } from 'redux';
import TaskService from 'src/services/TaskService';
import { STATUS_PROGRESS, STATUS_SUCCESS, STATUS_PENDING } from 'src/constants/ActionTypes';
import { ITaskInfo } from 'src/entity/TaskEntity';
import HttpService from 'src/services/HttpService';
import I18N from 'src/services/I18NService';
import { message, notification } from 'antd';

export function requestTask(taskId: string, percentage: number): IStateTask {
  return {
    type: STATUS_PROGRESS,
    taskid: taskId,
    percentage,
  };
}

export function receiveTask(taskId: string, res: ITaskInfo): IStateTask {
  return {
    type: res.status,
    taskid: taskId,
    result: res.result,
    errors: res.errors,
    percentage: res.percentage,
  };
}

export function requestTaskException(taskId: string, errors: string): IStateTask {
  return {
    type: STATUS_PROGRESS,
    taskid: taskId,
    errors,
  };
}

export function fetchTaskById(taskId: string, cbFun: any): any {
  return async (dispatch: Dispatch<IStateTask>) => {
    return TaskService.getTaskById(taskId)
      .then(async (res: ITaskInfo) => {
        if (res.status === STATUS_PENDING) {
          dispatch(requestTask(taskId, 0));
          await HttpService.setTimeout(200);
          dispatch(fetchTaskIfNeeded(cbFun));
        } else if (res.status === STATUS_PROGRESS) {
          dispatch(requestTask(taskId, res.percentage as number));
          await HttpService.setTimeout(5000);
          dispatch(fetchTaskIfNeeded(cbFun));
        } else if (res.status === STATUS_SUCCESS) {
          dispatch(receiveTask(taskId, res));
          cbFun();
          message.success(res.result);
        } else {
          dispatch(receiveTask(taskId, res));
          notification.error({
            message: I18N.get('err_import_failure'),
            description: res.errors,
            duration: null,
          });
        }
      })
      .catch(error => {
        dispatch(requestTaskException(taskId, error));
        message.error(error, 3);
      });
  };
}

export function fetchTaskIfNeeded(cbFun: any): any {
  return (dispatch: Dispatch<IStateTask>, getState: any) => {
    const storeState: IStoreState = getState();
    if (!!storeState.taskState.taskid) {
      return dispatch(fetchTaskById(storeState.taskState.taskid, cbFun));
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/taskCreator.ts